<template>
	<div class="progAction">
		<!-- <b-modal id="modal-progaction" size="xl" :max-width="'90%'">
			<template #modal-header>
				<h5>Plan d'actions</h5>
			</template>
			<b-table ref="tableProgActionShort" small responsive striped :items="this.editfields" :fields="fieldsProgActionShort" show-empty>
				<template slot="empty" slot-scope="">
					<div style="text-align:center;">Ce tiers ne possède aucun programme de prévention</div>
				</template>
				<template v-slot:cell(numAction)="data">
					<div contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="endEdit" :editId="data.item.numAction-1" editField='numAction' :dataInit="data.item.numAction">{{ data.item.numAction }}</div>
				</template> -->
				<!-- <template v-slot:cell(effet)="data">
                  	<div contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="endEdit" :editId="data.index" editField='effet' :dataInit="data.item.effet">{{ data.item.effet }}</div>
                </template> -->
				
				
				<!-- <template v-slot:cell(budget)="data">
					<div contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="endEdit" :editId="data.item.numAction-1" editField='budget' :dataInit="data.item.budget">{{ data.item.budget }}</div>
				</template>
				
			</b-table>
			<template #modal-footer="{ ok }">
				<b-button size="sm" variant="success" @click="ok()">OK</b-button>
			</template>
		</b-modal> -->
		<b-modal v-model="showFilterDialog" title="Filtrer par état">
			<el-select style="width:8vw;" v-model="criteria" @change="filterTable()" placeholder="Choisir un état">
				<el-option key="" label="Tous" value=""></el-option>
				<el-option v-for="item in etatsOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
		</b-modal>


		<h5>Programme de prévention</h5>
			<b-table ref="tableProgAction" small responsive striped :items="progAction" :fields="fieldsProgAction" :filter="criteria" show-empty>
                <template slot="empty" slot-scope="">
                  	<div style="text-align:center;">Ce tiers ne possède aucun programme de prévention</div>
                </template>
                <template v-slot:cell(numAction)="data">
                  	<div contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="endEdit" :editId="data.item.numProgAction" editField='numAction' :dataInit="data.item.numAction">{{ data.item.numAction }}</div>
                </template>
				<template v-slot:cell(typeAction)="data">
					<div style="max-width: 15vw; max-height: 28vw;" contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="endEdit" :editId="data.item.numProgAction" editField='typeAction' :dataInit="data.item.typeAction">{{ data.item.typeAction }}</div>
				</template>
				<template v-slot:cell(pilote)="data">
					<div style="max-width: 15vw; max-height: 28vw;" contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="endEdit" :editId="data.item.numProgAction" editField='pilote' :dataInit="data.item.pilote">{{ data.item.pilote }}</div>
				</template>
				<template v-slot:cell(dateSouhaitee)="data">
					<el-date-picker style="width:9vw;" type="date" placeholder="Choisissez une date" :editId="data.item.numProgAction" @change="changeDate" :dataInit="data.item.dateSouhaitee" editField='dateSouhaitee' v-model="data.item.dateSouhaitee" ></el-date-picker>
                </template>
				<template v-slot:cell(avancement)="data">
					<div contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="endEdit" :editId="data.item.numProgAction" editField='avancement' :dataInit="data.item.avancement">{{ data.item.avancement }}</div>
				</template>
                <template v-slot:cell(delai)="data">
					<el-date-picker style="width:9vw;" type="date" placeholder="Choisissez une date" :editId="data.item.numProgAction" @change="changeDate" :dataInit="data.item.delai" editField='delai' v-model="data.item.delai" ></el-date-picker>
                </template>
				<template v-slot:cell(commentaire)="data">
					<div style="max-width: 15vw; max-height: 28vw;" contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="endEdit" :editId="data.item.numProgAction" editField='commentaire' :dataInit="data.item.commentaire">{{ data.item.commentaire }}</div>
				</template>
				<template v-slot:head(etat)="data">
					<i class="fas fa-filter" @click="openFilterDialog"></i>
					État
				</template>
				<template v-slot:cell(etat)="data">
					<el-select style="width:8vw;" v-model="data.item.etat" @change="onChange()" placeholder="Choisir un état">
						<el-option v-for="item in etatsOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
                </template>
				<template v-slot:cell(actions)="data">
                  	<i class="far fa-trash-alt" @click="deleteRow(data.item.numProgAction, progAction)" style="color:red; cursor:pointer;"></i>
					<!-- <i class="far fa-edit" @click="ShowModal(data)" style="cursor:pointer;"></i> -->
                </template>
			</b-table>
			<el-button @click.native.prevent="addRow(progAction)" type="text" size="small"> Ajouter une ligne</el-button>
	</div>

</template>

<script>
import moment from "moment"
import script from '../../../script/script.js';
import scriptQse from '../../../script/script-qse.js';
export default {
	data(){
		return {
			dialogEditVisible: false,
			showFilterDialog: false,
			// fieldsProgActionShort:[
			// 	{key:"numAction", label:"N° Action"},
			// 	{key:"effet", label:"Effet attendu sur le risque concerné"},
			// 	{key:"pilote", label:"Pilote de l'action"},
			// 	{key:"avancement", label:"% avancement"},
			// 	{key:"commentaire", label:"Commentaire"},
			// ],
			fieldsProgAction:[
				{key:"numAction", label:"N° Action"},
				{key:"typeAction", label:"Action"},
				{key:"pilote", label:"Pilote de l'action"},
				{key:"dateSouhaitee", label:"Date souhaitée de réalisation"},
				{key:"avancement", label:"% avancement"},
				{key:"delai", label:"Date de réalisation"},
				{key:"commentaire", label:"Commentaire"},
				{key:"etat", label:"État"},
				{key:"actions", label:""},
			],
			editfields: [],
			etatsOptions: [{
				value: 'Soldée',
				label: 'Soldée'
				}, {
				value: 'En cours',
				label: 'En cours'
				}, {
				value: 'En retard',
				label: 'En retard'
			}],
			criteria:'',
		}
	},
	computed:{
		progAction(){
			let actions = this.$store.state.progAction;
			
			// Appliquer le filtre si un critère existe
			if (this.criteria) {
				actions = actions.filter((action) => action.etat == this.criteria);
			}
			
			// Trier par numAction en tant que nombres pour l'ordre croissant
			return [...actions].sort((a, b) => {
				// Convertir en nombres pour une comparaison numérique
				const numA = parseInt(a.numAction, 10);
				const numB = parseInt(b.numAction, 10);
				
				// Si les deux sont des nombres valides
				if (!isNaN(numA) && !isNaN(numB)) {
					return numA - numB; // Tri numérique croissant
				}
				
				// Si l'un n'est pas un nombre, on utilise la comparaison de chaînes
				return String(a.numAction).localeCompare(String(b.numAction));
			});
		},
		autoIncrementProgAction(){
			return this.$store.state.autoIncrementProgAction
		},
		famillesOptions(){
			let familles = this.$store.state.famillesRisques.familles
			let famillesOptions = []
			familles.forEach(famille => {
				famillesOptions.push({
					value:famille.nomFamille,
					label:famille.nomFamille
				})
			})
			return famillesOptions
		},
		unitesOptions(){
			let unites = this.$store.state.unites
			let unitesOptions = []
			unites.forEach(unite => {
				unitesOptions.push({
					value:unite.nomUnite,
					label:unite.nomUnite
				})
			})
			return unitesOptions
		}
	},
	methods:{
		updateExtrafieldsQse: scriptQse.updateExtrafieldsQse,
		deleteRow(numProgAction, rows) {
			if(confirm("Voulez-vous supprimer cette entrée ?")){
				// this.$store.commit("rebuildUniteActions", {id:numProgAction})
				var index = this.$store.state.progAction.findIndex(action => action.numProgAction == numProgAction)
				this.$store.state.progAction.splice(index, 1);
				this.$store.commit("updateProgAction", this.$store.state.progAction)
				this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
			}
		},
		addRow(rows) {
			let dateNow = moment().format("YYYY-MM-DD")
			this.$store.state.progAction.push({
				'numProgAction':this.autoIncrementProgAction,
				'numAction':'Saisir un numéro d\'action', 
				'risque':'', 
				'unite':[], 
				'situation':'Saisir une situation', 
				'typeAction':'Saisir la description de l\'action', 
				'effet':'Saisir l\'effet', 
				'pilote':'Saisir un pilote', 
				'delai': dateNow, 
				'dateSouhaitee': dateNow, 
				'avancement':'Saisir un avancement', 
				'budget':'Saisir un budget', 
				'commentaire':'Saisir un commentaire',
				'etat':'En cours'
			})
			this.$store.commit("updateAutoIncrementProgAction", parseInt(this.autoIncrementProgAction)+1)
			this.$store.commit("updateProgAction", this.$store.state.progAction)
			this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
		},
		onEdit (evt) {
			var initValue = evt.target.getAttribute('dataInit')
			var newValue = evt.target.innerText
			var editId = evt.target.getAttribute('editId')
			var editField = evt.target.getAttribute('editField')
			var index = this.$store.state.progAction.findIndex(action => action.numProgAction == editId)
			if (newValue !== initValue) {
				this.$store.state.progAction[index][editField] = newValue 
				this.$store.commit("updateProgAction", this.$store.state.progAction)
				evt.target.setAttribute('dataInit', newValue)
				this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
			}
		},
		changeDate () {
			this.$store.commit("updateProgAction", this.$store.state.progAction)
			this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
		},

		endEdit (evt) {
			evt.target.blur(evt)	
		},
		onChange(){
			this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
		},
		ShowModal(data){
			this.editfields = [this.$store.state.progAction[data.index]];
			this.$bvModal.show('modal-progaction');
		},
		openFilterDialog() {
			// Affichez la boîte de dialogue de filtre ou effectuez d'autres actions ici
			this.showFilterDialog = true;
		},
		filterTable(item) {
			if (!this.criteria) {
			// Si aucun critère de filtre n'est défini, affichez toutes les lignes.
			return true;
			}

			// Vérifiez si la valeur de l'état dans la ligne correspond au critère de filtrage.
			return item.etat.toLowerCase().includes(this.criteria.toLowerCase());
		},
	}
}
</script>

<style>
.progAction{
	text-align: center;
}

.progAction .table-responsive tbody tr{
	text-align: left;
}

.progAction .table-responsive{
	max-height: 490px;
}

.modal-dialog modal-lg{
	width: 90vw;
	max-width: 90%;
}

.modal-header {
	justify-content: center;
}
</style>